import type { HTMLAttributes } from 'react';

export type PageContentProps = HTMLAttributes<HTMLDivElement>;

export const PageContent = ({ children, ...props }: PageContentProps) => {
	return (
		<div className="page-content" {...props}>
			{children}
		</div>
	);
};

export default PageContent;
